import React, { Component } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { Link } from 'react-router-dom';
import { Table, Button, ButtonGroup, Row, Col, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import './App.css';


class LeaderBoard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            selectedUsers: []
        }
    }

    componentDidMount() {

        var usersRef = firebase.database().ref('user');
        usersRef.once('value', (snapshot) => {
            let data = snapshot.val();

            let keyArray = Object.keys(data);
            let usersArray = [];
            for (let temp of keyArray) {
                usersArray.push(data[temp])
            }
            this.setState({ users: usersArray, selectedUsers: usersArray })
        })

    }

    groupBySelected = (users) => {
        this.setState({
            selectedUsers: users
        })
    }

    render() {
        return (
            <div>
                <Row style={{ padding: '2em' }}>
                    <Col sm="2" md='3'>
                        <RankOptions users={this.state.selectedUsers} selectedUsers={this.state.users} groupBySelected={this.groupBySelected} />
                    </Col>
                    <Col>
                        <RankBoardHA users={this.state.selectedUsers} />
                        <RankBoardHB users={this.state.selectedUsers} />
                        <RankBoardC users={this.state.selectedUsers} />
                        <RankBoardD users={this.state.selectedUsers} />
                    </Col>
                </Row>
            </div>
        )
    }
}

class RankOptions extends Component {

    render() {

        return (
            <div>
                <h1 style={{paddingLeft:'2em'}}> Filter </h1>
                <ButtonGroup vertical style={{paddingLeft:'4em'}}>
                    <OverallRank users={this.props.selectedUsers} groupBySelected={this.props.groupBySelected} />
                    <RegionDropDown users={this.props.users} groupBySelected={this.props.groupBySelected} />
                    <RatingDropDown users={this.props.users} groupBySelected={this.props.groupBySelected} />
                    <Button color='info'> <Link to='/home' style={{textDecoration:'none', color:'white'}}> Back to Trivia Games </Link> </Button>
                </ButtonGroup>
            </div>

        )
    }
}

class OverallRank extends Component {

    handleClick = (event) => {
        this.props.groupBySelected(this.props.users);
    }

    render() {
        return (
            <Button color='primary' style={{ marginTop: '1em' }} onClick={(event) => this.handleClick(event)} > Overall </Button>
        )
    }

}

class RegionDropDown extends Component {
    state = {
        dropDownOpen: false,
        certs: ['Alaska', 'Big Sky', 'Capitol', 'Carolina', 'Deep South', 'Delmarva', 'Great Lakes', 'Hawaii', 'Heartland', 'Inland Empire', 'Intermountain', 'Lake Shore', 'Maryland', 'Metropolitan', 'Midsouth', 'Midwest', 'New Jersey',
            'North Central Prairie', 'Northeast', 'Northern Lakes', 'Northwest', 'Old Dominion', 'Oregon', 'Red River', 'Rio Grande', 'Rocky Mountain', 'Southwest', 'Sunshine', 'Tri-State', 'Virginia', 'Camino Real', 'Central New England',
            'Eastern Pennsylvania', 'Middle California', 'Sierra Pacific', 'South', 'Southern California', 'Upper York - Upper Connecticut', 'Western New England', 'Western New York', 'White Mountain', 'INTERNATIONAL']
    }

    toggle = () => {
        this.setState({
            dropDownOpen: !this.state.dropDownOpen,
        })
    }

    handleClick = (event, tag) => {
        let users = this.props.users
        var filtered = users.filter(function (user) {
            return user.region === tag.tag;
        });
        this.props.groupBySelected(filtered);

    }

    render() {
        let tags = [];
        for (let tag of this.state.certs) {
            tags.push(<DropdownItem key={tag} onClick={(event) => this.handleClick(event, { tag })}> {tag} </DropdownItem>)
        }
        return (
            <ButtonDropdown isOpen={this.state.dropDownOpen} toggle={this.toggle}>
                <DropdownToggle caret color='success' style={{ marginTop: '1em' }}> Region </DropdownToggle>
                <DropdownMenu>
                    {tags}
                </DropdownMenu>
            </ButtonDropdown>
        )
    }
}


class RatingDropDown extends Component {
    state = {
        dropDownOpen: false,
        certs: ['D-1', 'D-2', 'D-3', 'C-1', 'C-2', 'C+', 'H-B', 'C-3', 'B', 'H+', 'H-A', 'A', 'Unrated']
    }

    toggle = () => {
        this.setState({
            dropDownOpen: !this.state.dropDownOpen,
        })
    }

    handleClick = (event, tag) => {
        let users = this.props.users
        var filtered = users.filter(function (user) {
            return user.rating === tag.tag;
        });
        this.props.groupBySelected(filtered);

    }

    render() {
        let tags = [];
        for (let tag of this.state.certs) {
            tags.push(<DropdownItem key={tag} onClick={(event) => this.handleClick(event, { tag })}> {tag} </DropdownItem>)
        }
        return (
            <ButtonDropdown isOpen={this.state.dropDownOpen} toggle={this.toggle} style={{marginBottom:'1em'}}>
                <DropdownToggle caret color='danger' style={{ marginTop: '1em' }}> Certification </DropdownToggle>
                <DropdownMenu>
                    {tags}
                </DropdownMenu>
            </ButtonDropdown>
        )
    }
}

class RankBoardHA extends Component {

    render() {
        let pcArray = [];
        let rank = 0;
        let users = this.props.users

        users.sort(function (a, b) {
            return a.scoreHA - b.scoreHA;
        });

        users.reverse();

        for (let i = 0; i < users.length; i++) {
            rank = rank + 1;
            if (users[i].scoreHA > 0) {
                pcArray.push(
                    <tr key={users[i].name}>
                        <th scope="row">{rank}</th>
                        <td>{users[i].firstName} {users[i].lastName.charAt(0)}</td>
                        <td>{users[i].region}</td>
                        <td>{users[i].club}</td>
                        <td>{users[i].rating}</td>
                        <td>{users[i].scoreHA}</td>
                    </tr>
                )
            }
        }

        return (
            <div className='ha-leaderboard'>
                {/* <Card outline color="primary" style={{ padding: '2em' }}> */}
                    <h1> H-A Trivia Leader Board</h1>
                    <Table striped>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Region</th>
                                <th>Club</th>
                                <th>Certification</th>
                                <th> Score </th>
                            </tr>
                        </thead>
                        <tbody>
                            {pcArray}
                        </tbody>
                    </Table>
                
            </div>
        )
    }
}

class RankBoardHB extends Component {

    render() {
        let pcArray = [];
        let rank = 0;
        let users = this.props.users

        users.sort(function (a, b) {
            return a.scoreHB - b.scoreHB;
        });

        users.reverse();
        for (let i = 0; i < users.length; i++) {
            rank = rank + 1;
            if (users[i].scoreHB > 0) {
                pcArray.push(
                    <tr key={users[i].name}>
                        <th scope="row">{rank}</th>
                        <td>{users[i].firstName} {users[i].lastName.charAt(0)}</td>
                        <td>{users[i].region}</td>
                        <td>{users[i].club}</td>
                        <td>{users[i].rating}</td>
                        <td>{users[i].scoreHB}</td>
                    </tr>
                )
            }
        }

        return (
            <div className='hb-leaderboard'>
                
                    <h1> H-B Trivia Leader Board</h1>
                    <Table striped>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Region</th>
                                <th>Club</th>
                                <th>Certification</th>
                                <th> Score </th>
                            </tr>
                        </thead>
                        <tbody>
                            {pcArray}
                        </tbody>
                    </Table>
                
            </div>
        )
    }
}

class RankBoardC extends Component {

    render() {
        let pcArray = [];
        let rank = 0;
        let users = this.props.users

        users.sort(function (a, b) {
            return a.scoreC - b.scoreC;
        });

        users.reverse();
        for (let i = 0; i < users.length; i++) {
            rank = rank + 1;
            if (users[i].scoreC > 0) {
                pcArray.push(
                    <tr key={users[i].name}>
                        <th scope="row">{rank}</th>
                        <td>{users[i].firstName} {users[i].lastName.charAt(0)}</td>
                        <td>{users[i].region}</td>
                        <td>{users[i].club}</td>
                        <td>{users[i].rating}</td>
                        <td>{users[i].scoreC}</td>
                    </tr>
                )
            }
        }

        return (
            <div className='c-leaderboard'>
                
                    <h1> C-Level Trivia Leader Board</h1>
                    <Table striped>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Region</th>
                                <th>Club</th>
                                <th>Certification</th>
                                <th> Score </th>
                            </tr>
                        </thead>
                        <tbody>
                            {pcArray}
                        </tbody>
                    </Table>
                
            </div>
        )
    }
}

class RankBoardD extends Component {

    render() {
        let pcArray = [];
        let rank = 0;
        let users = this.props.users

        users.sort(function (a, b) {
            return a.scoreD - b.scoreD;
        });

        users.reverse();

        for (let i = 0; i < users.length; i++) {
            rank = rank + 1;
            if (users[i].scoreD > 0) {
                pcArray.push(
                    <tr key={users[i].name}>
                        <th scope="row">{rank}</th>
                        <td>{users[i].firstName} {users[i].lastName.charAt(0)}</td>
                        <td>{users[i].region}</td>
                        <td>{users[i].club}</td>
                        <td>{users[i].rating}</td>
                        <td>{users[i].scoreD}</td>
                    </tr>
                )
            }
        }

        return (
            <div className='d-leaderboard'>
                
                    <h1> D-Level Trivia Leader Board</h1>
                    <Table striped>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Region</th>
                                <th>Club</th>
                                <th>Certification</th>
                                <th> Score </th>
                            </tr>
                        </thead>
                        <tbody>
                            {pcArray}
                        </tbody>
                    </Table>
                
            </div>
        )
    }
}



export default LeaderBoard;